import { render, staticRenderFns } from "./mailing-lists.vue?vue&type=template&id=5b907c3e&"
import script from "./mailing-lists.vue?vue&type=script&lang=js&"
export * from "./mailing-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports